angular
    .module('claim.controller')
    .controller('claimSummaryController', ['$scope', '$rootScope', '$filter', '$controller', '$timeout', 'httpService', 'userService', 'commonService', 'commonConst', 'jurisdictionClaimEnum', 'claimSumm',
        function ($scope, $rootScope, $filter, $controller, $timeout, httpService, userService, commonService, commonConst, jurisdictionClaimEnum, claimSumm) {

            $scope.BindValueForCostCentreFilter = function (selectedCostCentre) {
                var lstCostCentre = selectedCostCentre || '';
                var costCentre = lstCostCentre instanceof Array ? lstCostCentre : lstCostCentre.split(',');

                $('#cost-centre').val(costCentre);

                $("#cost-centre").multiselect("refresh");
            }

            $scope.BindValueForStatusFilter = function (selectedStatus) {
                var lstStatus = selectedStatus || '';
                var status = lstStatus instanceof Array ? lstStatus : lstStatus.split(',');

                $('#claim-status-filter').val(status);

                $("#claim-status-filter").multiselect("refresh");
            }
            $scope.isSuperUser = $rootScope.user.IsSuperUser;

            $scope.lstUserJurisdiction = $filter('decstr64')(sessionStorage.ListJurisdictionId).split(",");
            $scope.jurisdictionLst = $scope.isSuperUser ? jurisdictionClaimEnum : Object.keys(jurisdictionClaimEnum).reduce(function (filtered, key) {
                if (jurisdictionClaimEnum[key] > 1 && $scope.lstUserJurisdiction.indexOf(jurisdictionClaimEnum[key].toString()) >= 0)
                    filtered[key] = jurisdictionClaimEnum[key];
                return filtered;
            }, {});
            $scope.init = function () {

                if ($filter('dec2bool')(sessionStorage.IsNsiUser)) {
                    //get notification when we got an issue          
                    commonService.getNotificationMessage();
                }
                if ($filter('dec2bool')(sessionStorage.LoggedIn)) {
                    userService.setUserArray();
                    userService.checkTermConditionAgree();

                    $rootScope.pageName = "My Claims Summary";

                }
                $controller('homeController', {
                    $scope: $scope
                });

                $scope.pageBreadcrumbs = [{
                    url: '/',
                    title: 'Home'
                }, {
                    url: null,
                    title: 'My Claims Summary'
                }];
                $scope.isDisableBackButton = true;
                $rootScope.pageName;
                $rootScope.etlTime;
                $scope.ClaimCount;
                $scope.ClaimPageCount;
                $scope.rowSelections = commonConst.ROWS_PER_PAGE_ITEMS;
                $rootScope.claimsPageSelected;
                $scope.filterJurisdiction = $rootScope.pageNavigationHistory.filterJurisdiction;
                $scope.Claims;
                $scope.ClaimPolicyNumber;
                $scope.ClaimEmployerName;
                $scope.unreadCountClaim = 0;
                $scope.resultSearchType = "";
                $scope.isFocusFilter = false;

                $rootScope.ClaimSummaryPage = true;
                $rootScope.PolicyDetailsPage = false;

                $scope.serverResponse;
                $scope.searchType = $rootScope.pageNavigationHistory.searchType || "claimnumber";
                $scope.claimSearchString = $rootScope.pageNavigationHistory.claimSearchString || '';
                $scope.isSearchClaim = $scope.claimSearchString ? true : false;
                $scope.rowPerPage = $rootScope.pageNavigationHistory.nsiClaimSumRowPerPage || 10;
                $scope.unreadOnly = $rootScope.pageNavigationHistory.unreadOnly || false;;
                $scope.allowSpecial = '"&\'()-./:';
                $scope.isPivotalUser = $filter('dec2bool')(sessionStorage.IsNsiUser);
                $rootScope.client = $filter('dec2num')(sessionStorage.ClientId);
                $scope.isSuperUser = $filter('dec2bool')(sessionStorage.IsSuperUser);


                $scope.paging = {
                    index: 1
                }

                $scope.getNSIClaimList = function (num) {

                    //console.log("My Claims list func")
                    $rootScope.claimsPageSelected = num;
                    $rootScope.pageNavigationHistory.LstCostCentre = $scope.lstCostCentre;
                    $rootScope.pageNavigationHistory.LstSelectedStatus = $scope.lstSelectedStatus;
                    $rootScope.pageNavigationHistory.nsiClaimSumRowPerPage = $scope.rowPerPage;
                    $rootScope.pageNavigationHistory.filterJurisdiction = $scope.filterJurisdiction;
                    $rootScope.pageNavigationHistory.unreadOnly = $scope.unreadOnly;
                    $rootScope.pageNavigationHistory.claimSearchString = $scope.claimSearchString;
                    $rootScope.pageNavigationHistory.searchType = $scope.searchType;
                    var APITarget = "api/policies/getnsipolicyclaimlist";
                    var Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        ClientId: $scope.clientId,
                        Keyword: $scope.claimSearchString,
                        strCostCentreId: $scope.lstCostCentre,
                        strClaimStatusId: $scope.lstSelectedStatus,
                        strJurisdictionId: $scope.filterJurisdiction ? $scope.filterJurisdiction.toString() : null,
                        RowsPerPage: $scope.rowPerPage,
                        PageNumber: num,
                        UnreadOnly: $scope.unreadOnly,
                        SearchType: $scope.searchType,
                        IsSuperUser: $scope.isSuperUser,
                    });
                    httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                        if (data !== false) {
                            if (data === "logout") {
                                $rootScope.userLogout();
                            }
                            $scope.serverResponse = angular.fromJson(data);
                            $scope.Claims = $scope.serverResponse;
                        } //if data==false
                    });
                }; //getPolicyList

                $scope.claimSummaryCount = function (p) {
                    var claimsPageSelected = !$filter('undefined')($rootScope.claimsPageSelected) ? $rootScope.claimsPageSelected : 1;

                    $rootScope.pageName = "My Claims Summary";

                    $scope.claimSearchString = $filter('undefined')($scope.claimSearchString) ? "" : $scope.claimSearchString;

                    var policyId = policyId || $rootScope.pageNavigationHistory.PolicyID;
                    $rootScope.claimsPageSelected = p ? p : claimsPageSelected;


                    var APITarget = "api/policies/getnsipolicyclaimpagecount";

                    var Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId,
                        Keyword: $scope.claimSearchString,
                        ClientId: $scope.clientId,
                        strCostCentreId: $scope.lstCostCentre,
                        strClaimStatusId: $scope.lstSelectedStatus,
                        strJurisdictionId: $scope.filterJurisdiction ? $scope.filterJurisdiction.toString() : null,
                        RowsPerPage: $scope.rowPerPage,
                        UnreadOnly: $scope.unreadOnly,
                        SearchType: $scope.searchType,
                        IsSuperUser: $scope.isSuperUser,
                    });

                    httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                        if (data !== false) {
                            if (data === "logout") {
                                $rootScope.userLogout();
                            }
                            $scope.serverResponse = angular.fromJson(data);
                            $scope.ClaimCount = $scope.serverResponse;
                            $rootScope.claimSummaryTotalClaims = $scope.ClaimCount;
                            $scope.ClaimPageCount = {
                                PolicyId: policyId,
                                Pages: []
                            };
                            var counterPage = 0;
                            for (var i = 0; i < $scope.ClaimCount; i++) {
                                counterPage++;
                                $scope.ClaimPageCount.Pages.push(counterPage);
                            }
                            $rootScope.claimsPageSelected = !$filter('undefined')($rootScope.claimsPageSelected) ? $rootScope.claimsPageSelected : 1;

                            $scope.claimSearchString = $filter('undefined')($scope.claimSearchString) ? "" : $scope.claimSearchString;

                            $scope.getNSIClaimList($rootScope.claimsPageSelected);
                        } //if data==false
                    });
                };


                //if ($scope.isSuperUser) {
                $scope.clients = $filter('dec2obj')(sessionStorage.getItem('NSIClients'));

                $scope.selectedClient = ($rootScope.pageNavigationHistory.SelectedClient == undefined) ? $scope.clients[0] : $rootScope.pageNavigationHistory.SelectedClient;
                $scope.clientId = $scope.selectedClient.ClientId;
                // }

                $scope.costCentres = $scope.loadAllCCFilterOption($scope.isSuperUser);
                $scope.lstCostCentre = $rootScope.pageNavigationHistory.LstCostCentre;

                $scope.claimStatus = $filter('dec2obj')(sessionStorage.getItem('LstClaimStatus'));
                $scope.lstSelectedStatus = $rootScope.pageNavigationHistory.LstSelectedStatus;

                userService.setUserArray();
                $scope.initFilter();
                $scope.claimSummaryCount(1);
                
                if ($rootScope.user.AllowReviewClaim) {
                    $scope.getNeedReviewClaimCountByClient($scope.clientId);
                }

                $scope.$watch('loaderOn', function () {
                    if ($rootScope.loaderOn == false) {
                        $timeout(function () {
                            $scope.initFilter();
                            if($scope.clientSelecting){
                                $('#claim-jurisdiction').multiselect($scope.ClaimJurisdictionVisibility());
                                $('#claim-status-filter').multiselect($scope.ClaimStatusVisibility());
                            }
                            $scope.clientSelecting = false;
                        }, 50);
                    }
                }, true);
            }

            $scope.clientSelecting = false;
            $scope.selectClient = function (selectedClient) {
                $scope.clientSelecting = true;
                $scope.selectedClient = selectedClient;
                $scope.clientId = selectedClient.ClientId;
                $rootScope.pageNavigationHistory.SelectedClient = $scope.selectedClient;

                //reset search text
                $scope.claimSearchString = "";
                $scope.resultMessage = "";
                $rootScope.pageNavigationHistory.claimSearchString = $scope.claimSearchString;
                $rootScope.pageNavigationHistory.searchType = $scope.searchType;
                $scope.isSearchClaim = false;
                $scope.unreadOnly = false;
                $scope.filterJurisdiction = null;
                $rootScope.pageNavigationHistory.filterJurisdiction = $scope.filterJurisdiction;
                $('#claim-jurisdiction').multiselect('deselectAll', false);
                //reset cost centre filter
                $scope.costCentres = $scope.loadAllCCFilterOption($scope.isSuperUser);
                var ccFilterDataProvider = $scope.CreateCCFilterDataProvider($scope.costCentres);
                $("#cost-centre").multiselect("dataprovider", ccFilterDataProvider);
                //$("#cost-centre + div ul li:nth-child(n+23):not(.multiselect-filter-hidden)").addClass('multiselect-filter-hidden').hide()
                
                $scope.lstCostCentre = '';
                $rootScope.pageNavigationHistory.LstCostCentre = '';

                //reset status filter
                $scope.lstSelectedStatus = '';
                $rootScope.pageNavigationHistory.LstSelectedStatus = '';

                $scope.claimSummaryCount(1);
                if ($rootScope.user.AllowReviewClaim) {
                    $scope.getNeedReviewClaimCountByClient($scope.clientId);
                }
            }

            $scope.CreateCCFilterDataProvider = function (lstCC) {
                var ccFilterDataProvider = [];
                angular.forEach(lstCC, function (cc) {
                    ccFilterDataProvider.push({
                        label: cc.CostCentreName + ' - ' + cc.CostCentreCode,
                        value: cc.CostCentreId,
                        selected: false
                    });
                });

                return ccFilterDataProvider;
            }

            $scope.loadAllCCFilterOption = function (isSuperUser) {
                var lstAllCostCentreFilterOption = $filter('dec2obj')(sessionStorage.getItem('LstCostCentre'));
                lstAllCostCentreFilterOption = lstAllCostCentreFilterOption.sort(function (a, b) {
                    return a.CostCentreName > b.CostCentreName ? 1 : -1;
                })
                var lstCC = [];

                // if (!isSuperUser && lstAllCostCentreFilterOption.length <= 20) {
                //     lstCC = lstAllCostCentreFilterOption;
                // } else if (!isSuperUser && lstAllCostCentreFilterOption.length > 20) {
                //     lstCC = [];
                // } else if (isSuperUser) {
                angular.forEach(lstAllCostCentreFilterOption, function (cc) {
                    if (cc.ClientId == $scope.clientId) {
                        lstCC.push(cc);
                    }
                });

                // if (lstCC.length > 20) {
                //     lstCC = [];
                // }
                //}

                return lstCC;
            }

            $scope.exportClaimSummary = function () {

                var APITarget = "api/vicclaims/exportnsiclaimexcelfile";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    Keyword: $scope.claimSearchString,
                    ClientId: $scope.clientId,
                    LstCostCentreId: $scope.lstCostCentre,
                    LstClaimStatusId: $scope.lstSelectedStatus,
                    LstJurisdictionId: $scope.filterJurisdiction ? $scope.filterJurisdiction.toString() : null,
                    IsSuperUser: $scope.isSuperUser,
                    UnreadOnly: $scope.unreadOnly,
                    SearchType: $scope.searchType,
                });

                var options = {
                    responseType: 'arraybuffer'
                };
                httpService.httpRequest(APITarget, Values, 'GET', options).then(function (data) { // this is only run after $http completes
                    if (angular.isDefined(data.File)) {
                        var file = new Blob([data.File], {
                            type: 'text/csv'
                        });
                        var fileName = 'ClaimSummary_' + $scope.selectedClient.ClientName + '_' + commonService.formatDate(new Date()) + '.csv';;

                        saveAs(file, fileName);
                        return true;
                    } else
                        return false;
                });
            };
            $scope.ClaimJurisdictionVisibility = function(){
                void 0;
                return (((!this.lstUserJurisdiction || this.lstUserJurisdiction.length <= 1) 
                && !this.isSuperUser ) || !this.Claims || this.Claims.length < 1) 
                ? 'disable': 'enable';
            }
            $scope.ClaimStatusVisibility = function(){
                void 0;
                return (!this.Claims || this.Claims.length < 1) 
                ? 'disable': 'enable';
            }
            $scope.initFilter = function () {
                if ($scope.isPivotalUser) {
                    $('#claim-jurisdiction').multiselect({
                        dropRight: true,
                        includeSelectAllOption: true,
                        selectedClass: '',
                        buttonText: function (ele, checked) {
                            return '';
                        },
                        templates: {
                            button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></i>'
                        },

                        onChange: function (ele, checked) {
                            $scope.filterJurisdiction = $('#claim-jurisdiction').val();
                            $scope.claimSummaryCount(1)
                        },
                        onSelectAll: function () {
                            $scope.filterJurisdiction = $('#claim-jurisdiction').val();
                            $scope.claimSummaryCount(1)
                        },
                        onDeselectAll: function () {
                            $scope.filterJurisdiction = null;
                            $scope.claimSummaryCount(1)
                        }
                    });
                    

                    $('#cost-centre').multiselect({
                        disableIfEmpty: true,
                        dropRight: true,
                        includeSelectAllOption: true,
                        enableFiltering: true,
                        enableCaseInsensitiveFiltering: true,
                        selectedClass: '',
                        numberDisplayed: 20,
                        buttonText: function (ele, checked) {
                            return '';
                        },
                        templates: {
                            button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></a>'
                        },
                        // onInitialized: function () {
                        //     $("#cost-centre + div ul li:nth-child(n+23):not(.multiselect-filter-hidden)").addClass('multiselect-filter-hidden').hide();
                        // },
                        onFiltering: function () {
                            if (this.query) {
                                var query = this.query;
                                costCentres = $scope.costCentres.filter(function (cc) {
                                    return cc.CostCentreCode.toLowerCase().indexOf(query.toLowerCase()) >= 0 || cc.CostCentreName.toLowerCase().indexOf(query.toLowerCase()) >= 0;
                                });

                                if (costCentres.length == 0 || !costCentres) {
                                    $('#cost-centre + div ul li:not(.multiselect-filter)').hide();
                                    $('#cost-centre + div ul li.multiselect-filter').after("<li class='no-result-costcenter'><a><label>No results matched</label></a></li>");
                                } else {
                                    var liafter = $(".no-result-costcenter");
                                    if (liafter)
                                        liafter.remove();
                                    $(".multiselect-all").show();
                                }
                            } else {
                                // $("#cost-centre + div ul li:nth-child(n+23):not(.multiselect-filter-hidden)").addClass('multiselect-filter-hidden').hide();

                                $(".multiselect-all").show();
                                var liafter = $(".no-result-costcenter");
                                if (liafter)
                                    liafter.remove();
                            }
                        },
                        onChange: function (ele, checked) {
                            var selectedCC = $('#cost-centre').val();

                            if (selectedCC == null) {
                                $scope.lstCostCentre = '';
                                $rootScope.pageNavigationHistory.LstCostCentre = '';
                            } else {
                                $scope.lstCostCentre = selectedCC.join();
                                $rootScope.pageNavigationHistory.LstCostCentre = selectedCC.join();
                            }

                            $scope.isSearchClaim = true;
                            $scope.claimSummaryCount(1)
                        },
                        onSelectAll: function (checked) {
                            $scope.lstCostCentre = $('#cost-centre').val().join();
                            $rootScope.pageNavigationHistory.LstCostCentre = $('#cost-centre').val().join();
                            $scope.isSearchClaim = true;
                            $scope.claimSummaryCount(1)
                        },
                        onDeselectAll: function (checked) {
                            $scope.lstCostCentre = '';
                            $rootScope.pageNavigationHistory.LstCostCentre = '';
                            $scope.isSearchClaim = true;
                            $scope.claimSummaryCount(1)
                        }
                        
                    });

                    $('#cost-centre + div  button.multiselect-clear-filter').click(function (event) {
                        // setTimeout(function () {
                        //     $("#cost-centre + div ul li:nth-child(n+23):not(.multiselect-filter-hidden)").addClass('multiselect-filter-hidden').hide();
                        // }, 1);
                        var liafter = $(".no-result-costcenter");
                        if (liafter)
                            liafter.remove();
                    })
                    //binding control status filter
                    $('#claim-status-filter').multiselect({
                        disableIfEmpty: true,
                        dropRight: true,
                        includeSelectAllOption: true,
                        selectedClass: '',
                        buttonText: function (ele, checked) {
                            return '';
                        },
                        templates: {
                            button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></a>'
                        },
                        onChange: function (ele, checked) {
                            var selectedStatus = $('#claim-status-filter').val();

                            if (selectedStatus == null) {
                                $scope.lstSelectedStatus = '';
                                $rootScope.pageNavigationHistory.LstSelectedStatus = '';
                            } else {
                                $scope.lstSelectedStatus = selectedStatus.join();
                                $rootScope.pageNavigationHistory.LstSelectedStatus = selectedStatus.join();
                            }

                            $scope.isSearchClaim = true;
                            $scope.claimSummaryCount(1)
                        },
                        onSelectAll: function (checked) {
                            $scope.lstSelectedStatus = $('#claim-status-filter').val().join();
                            $rootScope.pageNavigationHistory.LstSelectedStatus = $('#claim-status-filter').val().join();
                            $scope.isSearchClaim = true;
                            $scope.claimSummaryCount(1)
                        },
                        onDeselectAll: function (checked) {
                            $scope.lstSelectedStatus = '';
                            $rootScope.pageNavigationHistory.LstSelectedStatus = '';
                            $scope.isSearchClaim = true;
                            $scope.claimSummaryCount(1)
                        }
                    });
                    
                    var preSelectedCC = $rootScope.pageNavigationHistory.LstCostCentre;
                    $scope.BindValueForCostCentreFilter(preSelectedCC);

                    var preSelectedStatus = $rootScope.pageNavigationHistory.LstSelectedStatus;
                    $scope.BindValueForStatusFilter(preSelectedStatus);
                }

                $scope.searchClaim = function () {
                    $rootScope.pageNavigationHistory.claimSearchString = $scope.claimSearchString;
                    $rootScope.pageNavigationHistory.searchType = $scope.searchType;
                    $scope.isSearchClaim = true;
                    if ($scope.claimSearchString === $scope.resultMessage && $scope.searchType === $scope.resultSearchType) {
                        return;
                    }
                    $scope.resultMessage = $scope.claimSearchString;
                    $scope.resultSearchType = $scope.searchType;
                    $scope.claimSummaryCount(1);
                };

                $scope.selectRow = function (rowPerPage) {
                    $scope.rowPerPage = rowPerPage;
                    $scope.claimSummaryCount(1)
                }

                $rootScope.getClaimList = function (policyId, num) {
                    //console.log("My Claims list func");
                    $rootScope.claimsPageSelected = num;
                    $scope.claimSearchString = $filter('undefined')($scope.claimSearchString) ? "" : $scope.claimSearchString;
                    var APITarget = "api/policies/getpolicyclaimlist";
                    var Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId,
                        Keyword: $scope.claimSearchString,
                        RowsPerPage: $scope.rowPerPage,
                        PageNumber: num,
                        UnreadOnly: $scope.unreadOnly
                    });
                    httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                        if (data !== false) {
                            if (data === "logout") {
                                $rootScope.userLogout();
                            }
                            $scope.serverResponse = angular.fromJson(data);
                            $scope.Claims = $scope.serverResponse;
                        } //if data==false
                    });
                }; //getPolicyList

                $scope.goToPage = function (numberOfPage) {
                    if (numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.ClaimPageCount.Pages.length) {
                        return;
                    }

                    $scope.getNSIClaimList(numberOfPage);
                    $scope.numberOfPage = parseInt(numberOfPage);
                }

                //set disable Go button
                $scope.buttonGoDisabled = true;
                $scope.setVisibleButton = function (numberOfPage) {
                    $scope.numberOfPage = "";
                    if (!(numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.ClaimPageCount.Pages.length)) {
                        $scope.buttonGoDisabled = false;
                    } else {
                        $scope.buttonGoDisabled = true;
                    }
                    $scope.numberOfPage = numberOfPage;
                }
                
            }

            $scope.clearSearch = function () {
                $scope.claimSearchString = '';
                $scope.searchClaim(1);
            }

            $scope.switchNewClaimFilter = function () {
                $scope.unreadOnly = !$scope.unreadOnly;
                $scope.claimSummaryCount(1);
            }

            $scope.getNeedReviewClaimCountByClient = function (clientId) {
                claimSumm.getNeedReviewClaimCount(clientId).then(function (response) {
                    $scope.unreadCountClaim = response;
                });
            }

            $scope.getCountDisplay = function (count) {
                return count <= 100 ? count : '99+';
            }

            // setFilterList = function($container) {
            //     $("#cost-centre + div ul li:nth-child(n+23):not(.multiselect-filter-hidden)").addClass('multiselect-filter-hidden').hide();
            // }
        }
    ]);